module.exports = __webpack_public_path__ + "img/team-bg.53a51859.svg";